import React from 'react'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'

const ForgotPasswordForm = ({ email, setEmail, onSubmit, onBack, isLoading, errorMessage }) => {
    const { t } = useTranslation()

    const handleSubmit = (e) => {
        e.preventDefault()
        onSubmit(email)
    }

    return (
        <div className="new-password-container">
            <div className="modal-title">
                <p className="text-left font-bold text-3xl text-white">{t('newPassword')}</p>
            </div>
            <div className="text-left text-deselectPurple text-sm mt-2">
                <p>{t('enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount')}</p>
            </div>
            <div className="sign-up-section">
                <div className="">
                    <form onSubmit={handleSubmit}>
                        <div className="my-5">
                            <span className="text-white text-lg font-semibold text-left flex justify-start">{t('email')}</span>
                            <input
                                className="w-full text-white border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                id="new-password-email-input"
                                placeholder={t('email')}
                                style={{ backgroundColor: 'transparent' }}
                                value={email}
                                name="email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="error-message">{errorMessage}</div>
                        <div className="login-form-element-holder px-6 py-3">
                            <button
                                id="new-password-send-request-button"
                                className={`bg-highlightColor text-deepPurple py-3 text-lg font-semibold rounded-full w-full h-[50px] ${
                                    !isLoading ? 'hover:bg-darkPurple hover:text-white' : ''
                                } duration-[250ms] ease-in-out transition-all flex items-center justify-center`}
                                disabled={isLoading}
                            >
                                {isLoading ? <Loading primaryColor="#413F5E" /> : t('sendRequest')}
                            </button>
                        </div>
                    </form>
                </div>
                {onBack && (
                    <div>
                        <p className="login-missing-text">
                            <span className="login-missing-text-action" onClick={onBack}>
                                {t('backToLogin')}
                            </span>
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ForgotPasswordForm
